// Add your custom JS here.

document.addEventListener('DOMContentLoaded', function() {
    const topMenu = document.getElementById('top-menu');
    if (topMenu && topMenu.children.length >= 3) {
        const firstItem = topMenu.children[0];
        const secondItem = topMenu.children[1];
        const thirdItem = topMenu.children[2];
        
        // Truncate language switcher text to first 3 characters
        const firstItemSpan = firstItem.querySelector('.wpml-ls-native');
        const secondItemSpan = secondItem.querySelector('.wpml-ls-native');
        
        if (firstItemSpan) {
            firstItemSpan.textContent = firstItemSpan.textContent.substring(0, 3);
        }
        if (secondItemSpan) {
            secondItemSpan.textContent = secondItemSpan.textContent.substring(0, 3);
        }
        
        // Move first and second items after third item
        topMenu.insertBefore(secondItem, thirdItem.nextSibling);
        topMenu.insertBefore(firstItem, thirdItem.nextSibling);
    }
});
